// components/IdleTimerModal.tsx
import React from "react";
import { useTranslation } from "react-i18next";
import { useIdleTimerContext } from "../../context/IdleTimerContext";

interface IdleTimerModalProps {
    className?: string;
}

const IdleTimerModal: React.FC<IdleTimerModalProps> = ({ className = "" }) => {
    const { t } = useTranslation();
    const { showModal, countdown, dismissModal } = useIdleTimerContext();

    if (!showModal) return null;

    const formatTime = (seconds: number): string => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs.toString().padStart(2, "0")}`;
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div
                className={`bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl ${className}`}>
                <div className="text-center">
                    <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100 mb-4">
                        <svg
                            className="h-6 w-6 text-yellow-600"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
                            />
                        </svg>
                    </div>

                    <h3 className="text-lg font-medium text-gray-900 mb-2">
                        {t("components.idle_timer.title")}
                    </h3>

                    <p className="text-sm text-gray-500 mb-4">
                        {t("components.idle_timer.message")}
                    </p>

                    <div className="text-3xl font-bold text-red-600 mb-6">
                        {formatTime(countdown)}
                    </div>

                    <div className="flex justify-center">
                        <button
                            onClick={dismissModal}
                            className="inline-flex justify-center px-6 py-2 text-sm font-medium text-white bg-green-500 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                            {t("components.idle_timer.dismiss")}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IdleTimerModal;
